import connect from 'react-redux/es/connect/connect';

import Header from '../components/Header';
import { logoutUser } from '../actions/user';

const mapStateToProps = state => ({
    user: state.user.user,
    cartItemCount: state.cart.cartItems.length,
    customer: state.user.customer
});

const mapDispatchToProps = dispatch => ({
    logout: () => {
        dispatch(logoutUser());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
